import { setTerm } from './helpers';

export const setIsByDomRf = setTerm('domrf');
